import MessageBlock from "components/shared/MessageBlock";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import ChoosePublisherSignerModal from "../ChoosePublisherSignerModal";
import { useAgreementPageContext } from "../context/StateProvider";

interface IPublisherSignerWarning {}

const PublisherSignerWarning = () => {
    const [t] = useTranslation();
    const { hasAbilityToEditPublisherSigner } = useAgreementPageContext();
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <ChoosePublisherSignerModal
                open={showModal}
                onClose={() => setShowModal(false)}
                modalTitle={t("ContractValidationEdit.ChooseSignatory")}
                modalSubtitle={t("ContractValidationEdit.ChooseSignatorySubtitle")}
            />

            <MessageBlock
                type="error"
                text={t(`ContractValidationEdit.NoPublisherSigner_owner_${hasAbilityToEditPublisherSigner}`)}
                style={{ marginBottom: "16px" }}
                action={hasAbilityToEditPublisherSigner ? () => setShowModal(true) : undefined}
                actionText={" > " + t("ContractValidationEdit.ChooseSignatory")}
            />
        </>
    );
};

export default PublisherSignerWarning;
